import { render, staticRenderFns } from "./ColleageCard.vue?vue&type=template&id=f658e232&scoped=true&"
import script from "./ColleageCard.vue?vue&type=script&lang=js&"
export * from "./ColleageCard.vue?vue&type=script&lang=js&"
import style0 from "./ColleageCard.vue?vue&type=style&index=0&id=f658e232&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f658e232",
  null
  
)

export default component.exports